import { render, staticRenderFns } from "./ProjectsMultiselectV2.vue?vue&type=template&id=12743884"
import script from "./ProjectsMultiselectV2.vue?vue&type=script&lang=ts"
export * from "./ProjectsMultiselectV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12743884')) {
      api.createRecord('12743884', component.options)
    } else {
      api.reload('12743884', component.options)
    }
    module.hot.accept("./ProjectsMultiselectV2.vue?vue&type=template&id=12743884", function () {
      api.rerender('12743884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ProjectsMultiselectV2.vue"
export default component.exports